import { render, staticRenderFns } from "./indiPartners.vue?vue&type=template&id=083d7e1a&scoped=true"
import script from "./indiPartners.vue?vue&type=script&lang=js"
export * from "./indiPartners.vue?vue&type=script&lang=js"
import style0 from "./indiPartners.vue?vue&type=style&index=0&id=083d7e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d7e1a",
  null
  
)

export default component.exports